import { useState } from "react";

import PageHeader from "../../components/UI/PageHeader";
import PersonalInfo from "../../components/section/PersonalInfo";
import CompanyInfo from "../../components/section/CompanyInfo";
// import Security from "../../components/section/Security";

const MyAccount = () => {
  const [activeButton, setActiveButton] = useState(1);

  const handleButtonClick = (buttonIndex) => {
    setActiveButton(buttonIndex);
  };

  const getButtonStyle = (buttonIndex) =>
    activeButton === buttonIndex
      ? "text-[#3d5984] font-semibold"
      : "text-gray-500";

  const [confirmation, setConfirmation] = useState(false);

  const getConfirmation = (value) => {
    setConfirmation(value);
  };

  return (
    <>
      <PageHeader title="Account Information" />
      <div className="w-full flex justify-center bg-gray-100">
        <div className="relative w-full max-w-[600px] overflow-y-auto h-[calc(100vh-61px)] sm:h-[calc(100vh-73px)] md:h-[calc(100vh-69px)] lg:h-[calc(100vh-79px)] px-4 py-6">
          {confirmation && (
            <div className="absolute top-3 right-4 z-20 bg-white px-4 h-11 rounded-full shadow-lg border border-green-500/30 text-green-600 flex items-center gap-2 text-sm font-medium">
              <span>✓ Saved</span>
            </div>
          )}

          {/* segmented control */}
          <div className="w-full bg-gray-200/70 p-1 rounded-full">
            <div className="relative flex items-center w-full text-sm">
              <div
                className="absolute top-0 bottom-0 left-0 w-1/2 bg-white rounded-full shadow-sm transition-transform duration-300 ease-out"
                style={{
                  transform: `translateX(${(activeButton - 1) * 100}%)`,
                }}
              />
              <button
                onClick={() => handleButtonClick(1)}
                className={`relative z-10 w-1/2 py-2 rounded-full transition-colors duration-200 ${getButtonStyle(
                  1
                )}`}
              >
                Personal
              </button>
              <button
                onClick={() => handleButtonClick(2)}
                className={`relative z-10 w-1/2 py-2 rounded-full transition-colors duration-200 ${getButtonStyle(
                  2
                )}`}
              >
                Company
              </button>
            </div>
          </div>

          {/* form */}
          <div className="mt-5">
            {activeButton === 1 && <PersonalInfo onSuccess={getConfirmation} />}
            {activeButton === 2 && <CompanyInfo />}
          </div>
        </div>
      </div>
    </>
  );
};

export default MyAccount;
